module.exports = __webpack_public_path__ + "img/background_Image.968b4cb3.png";